import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FaxChartByTimeComponent } from './chart-by-time.component';
import { MatButton } from '@angular/material/button';

export interface MatMessagingChartZoomDialogData {
  chartData: any[];
  dialogTitle: string;
  chartType: 'line' | 'bar';
  startDate: string;
  endDate: string;
}

@Component({
    selector: 'app-mat-fax-chart-zoom-dialog',
    template: `
    <mat-dialog-content class="mat-typography" style="height: calc(100% - 95px); max-height: 100%">
      <app-fax-chart-by-time [data]="data.chartData" [chartType]="data.chartType" [startDate]="data.startDate" [endDate]="data.endDate" ></app-fax-chart-by-time>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Close</button>
    </mat-dialog-actions>
  `,
    standalone: true,
    imports: [
        CdkScrollable,
        MatDialogContent,
        FaxChartByTimeComponent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class MatFaxChartZoomDialogComponent implements OnInit, OnDestroy {

  constructor(public dialogRef: MatDialogRef<MatFaxChartZoomDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: MatMessagingChartZoomDialogData
  ) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }
}
